import { QRFC } from "./QRFC";

const AUDIT_REPORT_MODE_LIST = "list";
const AUDIT_REPORT_MODE_EXPORT_CSV = "export_csv";

export class QAuditReportRFC extends QRFC {
  constructor() {
    super();
  }

  InitAuditReportRFC(callbackObj) {
    this.InitRemoteCall(callbackObj, "POST", true, false);
    this.SetAllowStacked(true);
  }

  GetCallName() {
    return "qauditreport";
  }

  SetParams(orgName, user, options = {}) {
    this.AddEncodedParameter("org", orgName);
    this.AddEncodedParameter("user", user);
    this.AddEncodedParameter("mode", options.mode || AUDIT_REPORT_MODE_LIST);
    if (options.startDate) this.AddEncodedParameter("startDate", options.startDate);
    if (options.endDate) this.AddEncodedParameter("endDate", options.endDate);
    // Scalar single-value filters — backend matches with `==` directly.
    // (Earlier `eventTypes`-array contract is also still accepted server-side
    // for backwards compatibility, but the UI exclusively sends scalars now.)
    if (options.eventType) this.AddEncodedParameter("eventType", options.eventType);
    if (options.source) this.AddEncodedParameter("source", options.source);
    if (options.outcome) this.AddEncodedParameter("outcome", options.outcome);
    if (options.actorId) this.AddEncodedParameter("actorId", options.actorId);
    if (options.targetId) this.AddEncodedParameter("targetId", options.targetId);
    if (options.page != null) this.AddParameter("page", options.page);
    if (options.pageSize != null) this.AddParameter("pageSize", options.pageSize);
  }

  DoTransactionComplete(response, callBackObj) {
    let parsed;
    try {
      parsed = JSON.parse(response);
    } catch (e) {
      callBackObj.AuditReportResult(false, null);
      return;
    }
    callBackObj.AuditReportResult(parsed.success === true, parsed);
  }
}

QAuditReportRFC.MODE_LIST = AUDIT_REPORT_MODE_LIST;
QAuditReportRFC.MODE_EXPORT_CSV = AUDIT_REPORT_MODE_EXPORT_CSV;
